// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__9d--f","actionsCol":"EnrolledClinics_actionsCol__1adap"};